export const concatUrls = (strings: string[], queryParams?: string) =>
  `${strings.join('/')}${queryParams ? `?${queryParams}` : ''}`;
